import { ICONS } from 'src/assets/library';

export const navConfig = [
  {
    title: 'navMenu.dashboard',
    path: '/',
    icon: ICONS.dashboard,
  },
  {
    title: 'common.admin',
    path: '/administrator',
    icon: ICONS.user,
  },
  {
    title: 'navMenu.customer',
    path: '/customer',
    icon: ICONS.customer,
  },
  {
    title: 'navMenu.order',
    path: '/order',
    icon: ICONS.order,
  },
  {
    title: 'navMenu.inventory',
    path: '/inventory',
    icon: ICONS.inventory,
  },
  {
    title: 'navMenu.banks',
    path: '/banks',
    icon: ICONS.banks,
  },
  {
    title: 'navMenu.settings',
    path: '/settings',
    icon: ICONS.settings,
  },
];

export const notAuthNavConfig = [
  {
    title: 'navMenu.dashboard',
    path: '/',
    icon: ICONS.dashboard,
  },
  {
    title: 'navMenu.order',
    path: '/order',
    icon: ICONS.order,
  },
];
